import React from 'react';
import './styles.css';
import './StaffSlider.css'; // Impor CSS lama (jika ada style .staff-card yang relevan)

const TenagaPendidik = ({ pendidik, kependidikan, loading }) => {

  if (loading) {
    return (
      <section className="section">
        <div className="container" style={{ textAlign: 'center' }}>
          <h2>Tenaga Pendidik & Kependidikan</h2>
          <p>Memuat data...</p>
        </div>
      </section>
    );
  }

  const hasPendidik = pendidik && pendidik.length > 0;
  const hasKependidikan = kependidikan && kependidikan.length > 0;

  if (!loading && !hasPendidik && !hasKependidikan) {
    return (
      <section className="section">
        <div className="container">
          <h2>Tenaga Pendidik & Kependidikan</h2>
          <p style={{ textAlign: 'center', marginTop: '20px' }}>Data tenaga pendidik dan kependidikan belum tersedia.</p>
        </div>
      </section>
    );
  }

  const renderStaffGrid = (title, staffList) => {
    if (!staffList || staffList.length === 0) return null;

    return (
      <>
        <h3 className="staff-subtitle">{title}</h3>
        <div className="staff-slider-container">
          {staffList.map((staff) => (
            <div key={staff.id} className="staff-card">
              <div className="staff-card-image-container">
                <img src={staff.image || 'https://via.placeholder.com/250'} alt={staff.name} className="staff-card-image" loading="lazy" />
              </div>
              <div className="staff-card-info">
                <h4 className="staff-card-name">{staff.name}</h4>
                <p className="staff-card-role">{staff.role}</p>
              </div>
            </div>
          ))}
        </div>
      </>
    );
  };

  return (
    <section className="section">
      <div className="container">
        <h2>Tenaga Pendidik & Kependidikan</h2>
        {renderStaffGrid('Tenaga Pendidik', pendidik)}
        {renderStaffGrid('Tenaga Kependidikan', kependidikan)}
      </div>
    </section>
  );
};

export default TenagaPendidik;